import { render, staticRenderFns } from "./headerItemDv1.vue?vue&type=template&id=33ecd404&scoped=true"
import script from "./headerItemDv1.vue?vue&type=script&lang=js"
export * from "./headerItemDv1.vue?vue&type=script&lang=js"
import style0 from "./headerItemDv1.vue?vue&type=style&index=0&id=33ecd404&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ecd404",
  null
  
)

export default component.exports